document.documentElement.classList.remove('no-js');

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-kb-country-selector]').forEach((selector) => {
    selector.addEventListener('change', () => selector.form && selector.form.submit());
  });

  // Menu toggle
  const menuToggle = document.querySelector('[data-kb-menu-toggle]');
  if (menuToggle) {
    menuToggle.addEventListener('click', () => {
      document.body.classList.toggle('kb-menu-open');
      menuToggle.setAttribute('aria-expanded', String(document.body.classList.contains('kb-menu-open')));
    });
  }

  // Scroll to top
  document.querySelectorAll('[data-kb-scroll-top]').forEach((button) => {
    button.addEventListener('click', () => window.scrollTo({ top: 0, behavior: 'smooth' }));
  });

  // Delayed floating contact bar — show after 2s or 300px scroll
  const floatingContact = document.querySelector('.kb-floating-contact');
  if (floatingContact) {
    floatingContact.style.opacity = '0';
    floatingContact.style.pointerEvents = 'none';
    floatingContact.style.transition = 'opacity 0.4s';
    let shown = false;
    function showFloating() {
      if (shown) return;
      shown = true;
      floatingContact.style.opacity = '1';
      floatingContact.style.pointerEvents = 'auto';
    }
    setTimeout(showFloating, 2000);
    window.addEventListener('scroll', () => { if (window.scrollY > 300) showFloating(); }, { passive: true });
  }

  // Gallery thumbnail swap
  document.querySelectorAll('[data-kb-gallery-thumb]').forEach((thumb) => {
    thumb.addEventListener('click', () => {
      const gallery = thumb.closest('[data-kb-gallery]');
      const main = gallery && gallery.querySelector('[data-kb-gallery-main]');
      const img = thumb.querySelector('img');
      if (!main || !img) return;
      main.src = thumb.dataset.fullSrc || img.src;
      main.alt = img.alt || main.alt;
    });
  });

  // Hero carousel with touch, pause-on-hover, and dots
  document.querySelectorAll('.kb-hero').forEach((hero) => {
    const slides = Array.from(hero.querySelectorAll('.kb-hero__slide'));
    if (slides.length < 2) return;

    let index = slides.findIndex((slide) => !slide.hidden);
    if (index < 0) index = 0;
    let paused = false;
    let timer = null;

    function goTo(i) {
      slides[index].hidden = true;
      index = (i + slides.length) % slides.length;
      slides[index].hidden = false;
      updateDots();
    }

    function startTimer() {
      clearInterval(timer);
      timer = setInterval(() => { if (!paused) goTo(index + 1); }, 5500);
    }

    // Create dot indicators
    const dots = document.createElement('div');
    dots.className = 'kb-hero__dots';
    dots.setAttribute('aria-label', 'Slide indicators');
    slides.forEach((_, i) => {
      const dot = document.createElement('button');
      dot.className = 'kb-hero__dot' + (i === index ? ' kb-hero__dot--active' : '');
      dot.type = 'button';
      dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
      dot.addEventListener('click', () => { goTo(i); startTimer(); });
      dots.appendChild(dot);
    });
    hero.appendChild(dots);

    function updateDots() {
      dots.querySelectorAll('.kb-hero__dot').forEach((d, i) => {
        d.classList.toggle('kb-hero__dot--active', i === index);
      });
    }

    // Pause on hover
    hero.addEventListener('mouseenter', () => { paused = true; });
    hero.addEventListener('mouseleave', () => { paused = false; });

    // Touch swipe support
    let touchStartX = 0;
    let touchEndX = 0;

    hero.addEventListener('touchstart', (e) => {
      touchStartX = e.changedTouches[0].screenX;
    }, { passive: true });

    hero.addEventListener('touchend', (e) => {
      touchEndX = e.changedTouches[0].screenX;
      const diff = touchStartX - touchEndX;
      if (Math.abs(diff) > 50) {
        if (diff > 0) goTo(index + 1); // swipe left = next
        else goTo(index - 1); // swipe right = prev
        startTimer();
      }
    }, { passive: true });

    startTimer();
  });
});
